import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Department } from 'src/app/models/department.model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';

import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button'; // Ensure Department type is imported

@Component({
  selector: 'app-update-wiki-article-dialog',
  templateUrl: './wiki-article-update-permissions-dialog.component.html',
  styleUrls: ['./wiki-article-update-permissions-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
})
export class WikiArticleUpdateDialogComponent implements OnInit {
  protected fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<WikiArticleUpdateDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private permissionsService = inject(PermissionsService);

  form: FormGroup;
  availableDepartments: Department[] = [];
  isEditMode = false;

  constructor() {
    const data = this.data;

    this.isEditMode = !!data;

    this.form = this.fb.group({
      categories: [data?.allowed_department_ids || []],
    });
  }

  ngOnInit(): void {
    this.availableDepartments = Object.values(this.permissionsService.getCurrentDepartments() || {}) as Department[];

    if (this.isEditMode && this.data?.element) {
      this.form.patchValue({
        name: this.data.element.name,
        categories: this.data.element.allowed_department_ids,
      });
    }
  }

  onConfirm(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
